<template>
  <div :class="classes" role="separator" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

/** UiDivider — Vuetify <v-divider> replacement. */
const props = withDefaults(defineProps<{ vertical?: boolean }>(), {
  vertical: false,
})
const classes = computed(() =>
  props.vertical
    ? 'self-stretch w-px bg-gray-400/20 mx-2'
    : 'border-0 border-t border-gray-400/20 my-2',
)
</script>
